import { Splide } from "../main.js";

// Variant circle dimensions — must match fixedWidth/fixedHeight + gap below.
const VARIANT_SIZE = 28;
const VARIANT_GAP = 10;

// Track width that fits exactly `count` whole variant circles, so no circle is
// ever clipped by the track's overflow:hidden.
const variantTrackWidth = (count) =>
  count * VARIANT_SIZE + (count - 1) * VARIANT_GAP;

// Number of circles shown at once. With a centered active circle the track can
// only show whole circles when the count is odd (otherwise the edge circles are
// cut in half), so force the count odd whenever the active circle is centered.
const visibleVariants = (length, maxVisible, centered) => {
  let visible = Math.min(length, maxVisible);
  if (centered && visible % 2 === 0) visible -= 1;
  return Math.max(visible, 1);
};

const productCardInit = async (productCards) => {
  await Promise.all(
    Array.from(productCards).map(async (card) => {
      // GLOBAL LOOP
      let productCardThumbnails;
      let productCardPhoto;

      // VARIANTS variables
      const cardVariant = await card.querySelector(".js-variant-product-card");

      const productVariantLength = await card
        .querySelector(".js-variant-product-card")
        .querySelectorAll(".splide__slide").length;

      // PHOTO variables
      const cardPhoto = await card.querySelector(".js-product-card-photo");
      const cardPhotoNextButton = await card.querySelector(
        ".product-card__right-button",
      );
      const cardPhotoPrevButton = await card.querySelector(
        ".product-card__left-button",
      );

      // VARIANTS SETTINGS
      const isCentered = productVariantLength > 3;
      // Odd, whole-circle counts per breakpoint so edge circles are never clipped.
      const visibleDefault = visibleVariants(productVariantLength, 7, isCentered);
      const visible1024 = visibleVariants(productVariantLength, 5, isCentered);
      const visible640 = visibleVariants(productVariantLength, 3, isCentered);

      productCardThumbnails = await new Splide(cardVariant, {
        rewind: true,
        width: variantTrackWidth(visibleDefault),
        perPage: visibleDefault,
        fixedWidth: VARIANT_SIZE,
        fixedHeight: VARIANT_SIZE,
        isNavigation: true,
        gap: VARIANT_GAP,
        speed: 200,
        rewindSpeed: 100,
        focus: isCentered ? "center" : 0,
        easing: "cubic-bezier(.06,.78,.49,.98)",
        type: isCentered ? "loop" : "slide",
        pagination: false,
        arrows: false,
        drag: false,
        wheel: false,
        breakpoints: {
          1024: {
            width: variantTrackWidth(visible1024),
            perPage: visible1024,
          },

          640: {
            width: variantTrackWidth(visible640),
            perPage: visible640,
          },
        },
      });

      // PHOTO SETTINGS
      const isInFrameCarousel = !!card.closest(".frame-carousel");
      productCardPhoto = new Splide(cardPhoto, {
        type: isInFrameCarousel ? "slide" : "loop",
        // heightRatio: 0.5,
        pagination: false,
        arrows: false,
        cover: !isInFrameCarousel,
        speed: 700,
        lazyLoad: "sequential",
        drag: !isInFrameCarousel,
      });

      // Init
      await productCardThumbnails.mount();
      await productCardPhoto.mount();
      await productCardPhoto.sync(productCardThumbnails);

      //attach events to custom buttons
      if (cardPhotoNextButton) {
        cardPhotoNextButton.addEventListener("click", (e) => {
          productCardPhoto.go("+1");
        });
      }

      if (cardPhotoPrevButton) {
        cardPhotoPrevButton.addEventListener("click", (e) => {
          productCardPhoto.go("-1");
        });
      }

      // Refresh inner sliders when outer frame-carousel reflows on window resize
      // (loop-mode clone reshuffling can leave nested Splides with stale layout)
      if (isInFrameCarousel) {
        let resizeTimer;
        window.addEventListener("resize", () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            productCardThumbnails.refresh();
            productCardPhoto.refresh();
          }, 200);
        });
      }
    }),
  );
};

document.addEventListener("DOMContentLoaded", function () {
  // Product variants sliders
  const productCards = document.querySelectorAll(".js-splide-product-card");
  if (productCards && productCards.length > 0) {
    productCardInit(productCards)
      .then(() => {
        // const splide
        console.log("All product cards initialized");
      })
      .catch((error) =>
        console.error("Error initializing product cards", error),
      );
  }
});
